import { render, staticRenderFns } from "./SnackBar.vue?vue&type=template&id=0ae8663e"
import script from "./SnackBar.vue?vue&type=script&lang=js"
export * from "./SnackBar.vue?vue&type=script&lang=js"
import style0 from "./SnackBar.vue?vue&type=style&index=0&id=0ae8663e&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ae8663e')) {
      api.createRecord('0ae8663e', component.options)
    } else {
      api.reload('0ae8663e', component.options)
    }
    module.hot.accept("./SnackBar.vue?vue&type=template&id=0ae8663e", function () {
      api.rerender('0ae8663e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/inc/SnackBar.vue"
export default component.exports